import React from "react";
import { Checkbox } from "semantic-ui-react";

const SimpleToggleComponent = ({
  name,
  label = "",
  value,
  onChange = () => {},
  className = "flex-row-center",
  labelClassName = "pr-1",
}) => {
  return (
    <div className={className}>
      {label && (
        <label className={labelClassName}>
          <b>{label}</b>
        </label>
      )}
      <Checkbox toggle value={value} onChange={onChange} />
    </div>
  );
};

export default SimpleToggleComponent;
